import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const HeroPhoto = styled.div<{ $imageUrl?: string }>`
  width: 100%;
  height: 280px;
  border-radius: ${vimovaTheme.borderRadius.signature};
  background: ${({ $imageUrl }) =>
    $imageUrl
      ? `url(${$imageUrl}) center/cover no-repeat`
      : vimovaTheme.colors.backgroundMuted};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;

  @media print {
    height: 280px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    background: ${({ $imageUrl }) =>
      $imageUrl
        ? `url(${$imageUrl}) center/cover no-repeat`
        : 'transparent'} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PhotoRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;

  @media print {
    display: flex !important;
    gap: 12px !important;
    margin-top: 12px !important;
  }
`

export const Photo = styled.div<{ $imageUrl?: string }>`
  flex: 1;
  height: 185px;
  border-radius: ${vimovaTheme.borderRadius.signature};
  background: ${({ $imageUrl }) =>
    $imageUrl
      ? `url(${$imageUrl}) center/cover no-repeat`
      : vimovaTheme.colors.backgroundMuted};
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    height: 185px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    background: ${({ $imageUrl }) =>
      $imageUrl
        ? `url(${$imageUrl}) center/cover no-repeat`
        : 'transparent'} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PhotoPlaceholder = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.textLight};

  /* Hidden in the PDF — empty photo slots stay blank, no "Photo N" label. */
  @media print {
    display: none !important;
  }
`

export const PhotoEditOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  font-family: ${vimovaTheme.fonts.heading};
  font-size: ${vimovaTheme.fontSizes.body};
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};

  *:hover > & {
    opacity: 1;
  }

  @media print {
    display: none !important;
  }
`
